import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, of } from 'rxjs';
import { catchError, finalize, switchMap, take } from 'rxjs/operators';
import { LessorList } from 'src/app/api/models/lessor.model';
import { LessorService } from 'src/app/api/services/lessor.service';
import * as fromAdresse from 'src/app/core/state/address';
import { AddressState } from 'src/app/core/state/address';
import { State } from 'src/app/core/state/core.state';

@Injectable({
  providedIn: 'root'
})
export class LessorResolver implements Resolve<LessorList> {
  constructor(
    private store: Store<State>,
    private lessorService: LessorService,
    private spinner: NgxSpinnerService
  ) {}

  resolve(): Observable<LessorList> {
    this.spinner.show();

    return this.store.select(fromAdresse.selectAddress).pipe(
      take(1),
      switchMap((address: AddressState) => {
        let zipCode = '';
        if (address.addresseSelection?.AdresseEsh.CodePostal)
          zipCode = address.addresseSelection.AdresseEsh.CodePostal;
        else if (address.addresseManuelle.CodePostal) zipCode = address.addresseManuelle.CodePostal;
        else if (address.adresseEsh?.CodePostal) zipCode = address.adresseEsh.CodePostal;

        return this.lessorService.GetLessorsListByZipCode(zipCode);
      }),
      finalize(() => this.spinner.hide()),
      catchError(() => of([]))
    );
  }
}
